"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManOfThePeople = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var SendDelegateToArea_1 = require("../../../deferredActions/SendDelegateToArea");
var Size_1 = require("../../render/Size");
var ManOfThePeople = (function (_super) {
    __extends(ManOfThePeople, _super);
    function ManOfThePeople() {
        return _super.call(this, {
            name: CardName_1.CardName.MAN_OF_THE_PEOPLE,
            tags: [Tags_1.Tags.WILDCARD],
            metadata: {
                cardNumber: 'L402',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.delegates(2);
                    b.text('Place 2 delegates from the reserve in 1 party.', Size_1.Size.SMALL).br;
                    b.effect('You have +1 influence.', function (eb) {
                        eb.startEffect.influence(1);
                    }).br;
                    b.effect('You may ignore all turmoil ruling party requirements.', function (eb) {
                        eb.plate('Party requirements').startEffect.text('None');
                    });
                }),
            },
        }) || this;
    }
    ManOfThePeople.prototype.play = function (player) {
        if (player.game.turmoil) {
            player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send the 2 delegates', { count: 2, source: 'reserve' }));
            player.game.turmoil.addInfluenceBonus(player);
        }
        return undefined;
    };
    return ManOfThePeople;
}(PreludeCard_1.PreludeCard));
exports.ManOfThePeople = ManOfThePeople;
//# sourceMappingURL=ManOfThePeople.js.map